$ = require 'jquery'
_ = require 'underscore'
View = require 'view'
entOrgPrefsAttachmentRestrictions = require 'views/templates/ent_org_prefs_attachment_restrictions'

module.exports = class OrganizationRestrictBoardVisibilityView extends View
  viewTitleKey: 'attachment restrictions'

  initialize: ->
    @listenTo @model, 'change:organizationPrefs', @frameDebounce @render

  events:
    'click a': 'changeRestriction'

  render: ->
    attachmentRestrictions = @model.getAttachmentRestrictions()

    @$el.html(entOrgPrefsAttachmentRestrictions(attachmentRestrictions))

    @

  changeRestriction: (e) ->
    $target = $(e.target)

    prefName = "attachmentRestrictions"
    targetValue = $target.closest('a').attr('data-value')

    return unless targetValue

    currentSetting = @model.getAttachmentRestrictions().enabled
    newSetting = if targetValue in currentSetting
      _.without(currentSetting, targetValue)
    else
      currentSetting.concat([targetValue])

    @model.setOrganizationPref(prefName, newSetting)




// WEBPACK FOOTER //
// ./app/scripts/views/enterprise/dashboard/teams-settings/organization-restrict-attachments-view.coffee